import gql from 'graphql-tag';

export const GET_BROADCASTS_SHARED_WITH_ACCOUNT = gql`
  query GetBroadcastsSharedWithAccount {
    broadcast {
      broadcastsSharedWithAccount {
        broadcastId
        accountId
        type
        title
        bodyPreview
        effectiveDateTime
        account {
          name
          logo
        }
        broadcastToUser {
          broadcastToUserId
          status
        }
      }
    }
  }
`;
